import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format material code
export function formatCode(productType, familyCode, sequential, revision = 0) {
  const noRevisionTypes = [2, 3, 4, 7, 9];
  const familyStr = familyCode.toString().padStart(3, '0');
  const seqStr = sequential.toString().padStart(5, '0');
  
  if (noRevisionTypes.includes(productType)) {
    return `${productType}-${familyStr}-${seqStr}`;
  }
  const revStr = revision.toString().padStart(2, '0');
  return `${productType}-${familyStr}-${seqStr}-${revStr}`;
}

// Role badge color
export function getRoleBadgeClass(role) {
  switch (role) {
    case 'admin':
      return 'bg-violet-600 text-white';
    case 'engenharia':
      return 'bg-blue-600 text-white';
    case 'orcamentos':
      return 'bg-emerald-600 text-white';
    case 'visualizacao':
      return 'bg-slate-500 text-white';
    default:
      return 'bg-slate-400 text-white';
  }
}

// Role display name
export function getRoleDisplayName(role) {
  switch (role) {
    case 'admin':
      return 'Administrador';
    case 'engenharia':
      return 'Engenharia';
    case 'orcamentos':
      return 'Orçamentos';
    case 'visualizacao':
      return 'Visualização';
    default:
      return role;
  }
}

// Product types
export const PRODUCT_TYPES = {
  1: "Produto Acabado",
  2: "Ativo Fixo",
  3: "Matéria Prima",
  4: "Itens de Fixação",
  5: "Consignados",
  6: "Itens Comprados Prontos",
  7: "Eletroeletrônicos",
  8: "Semi-Acabados",
  9: "Consumo Geral",
  10: "Serviços"
};
